/**
 * botRelicSeek — nearest allied active health relic when HP < 50% (FID-BOT-18).
 *
 * Pure JS — no Three.js, no DOM.
 */

export const BOT_RELIC_SEEK_HP = 0.50;

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

function isAlliedRelic(relic, team) {
  const id = String(relic?.id || '');
  const chaos = team === 'red' || team === 'chaos';
  return chaos ? id.includes('red') : id.includes('blue');
}

function isActiveRelic(relic) {
  if (!relic) return false;
  if (relic.active === false || relic.isAvailable === false) return false;
  return true;
}

export function alliedRelicSeekTarget(bot, relics = []) {
  if (!bot) return null;
  const ratio = bot.hp / (bot.maxHp || 1);
  if (!(ratio < BOT_RELIC_SEEK_HP)) return null;
  let best = null;
  let bestDist = Infinity;
  for (const relic of relics) {
    if (!isActiveRelic(relic) || !isAlliedRelic(relic, bot.team)) continue;
    const dist = Math.hypot(relic.x - bot.x, entityZ(relic) - entityZ(bot));
    if (dist < bestDist) {
      bestDist = dist;
      best = relic;
    }
  }
  if (!best) return null;
  return { x: best.x, z: entityZ(best) };
}
